// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { ownerFragment, spaceRoomFragment } from 'common/fragments/www'
import { viewerFragment } from 'common/fragments'

const spaceGQL = gql`
  query SpaceContainer($username: String, $orderBy: RoomOrder) {
    space(username: $username, rentType: DAY_TIME) {
      username
      breadcrumbs {
        title
        path
      }
      name
      state
      stateText
      spaceTypeText
      city
      username
      access
      postalCode
      address1
      address2
      latitude
      longitude
      rooms(page: 1, perPage: 20, orderBy: $orderBy) {
        results {
          ${spaceRoomFragment}
        }
      }
      owner {
        ${ownerFragment}
      }
      reputationScore
      reputationsCount
      reputations(page: 1, perPage: 3) {
        results {
          id
          createdAt
          score
          description
          reservation {
            startedAt
            numberOfGuests
            room {
              id
              name
            }
          }
          from {
            ... on User {
              profileImage
              username
              name
            }
          }
          room {
            id
            uid
            pageTitle
          }
        }
      }
    }
    promotions(page: 1) {
      results {
        backgroundColor
        backgroundImage
        endedAt
        id
        linkColor
        textColor
        title
      }
    }
    viewer {
      ${viewerFragment}
    }
}
`

export default function(component: any) {
  return graphql(spaceGQL, {
    options: props => ({
      variables: {
        username: props.match.params.spaceUsername || '',
        orderBy: null,
      },
    }),
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/pages/SpacePage/graphql.js